// src/components/Header.js
import React, { useState, useEffect, useRef } from 'react';
import Background from './Background';
import Logo from './Logo';
import LinkElement from './Link';
import TitleElement from './Title';
import NavigationMenu from './NavigationMenu';

const Header = ({ Background: backgroundData, Logo: logoData, Link, Title }) => {

const [isMenuOpen, setIsMenuOpen] = useState(false);
const menuRef = useRef(null); 

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Bestimme, ob Links direkt oder über das Menü-Umschaltbild angezeigt werden sollen
  const showCollapsibleMenu = Link && Link.length > 3; 

  // --- useEffect für "Click Outside" Logik ---
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Wenn das Menü offen ist UND der Klick NICHT im Menü-Container erfolgte
      // UND der Klick NICHT auf dem Hamburger-Bild selbst erfolgte
      // dann schließe das Menü.
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(event.target) && event.target.className !== 'menu-toggle-image') {
        setIsMenuOpen(false);
      }
    };

    // Füge den Event Listener hinzu, wenn das Menü geöffnet ist
    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Bereinige den Event Listener, wenn das Menü geschlossen wird oder die Komponente unmountet
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]); // Abhängigkeit ist isMenuOpen, damit der Listener aktualisiert wird, wenn sich der Zustand ändert

  // --- Ende "Click Outside" Logik ---



  return (
    <header className="position-relative p-3 bg-light min-vh-10 d-flex flex-column flex-sm-row align-items-center justify-content-between overflow-visible">
      {backgroundData && <Background {...backgroundData} />}

      <div className="position-relative z-index-1 d-flex flex-column flex-sm-row align-items-center w-100 ms-sm-3 me-sm-3 pt-sm-3">
        {logoData && <Logo {...logoData} />}

        {Title && Title.length > 0 && (
          <div className="text-center flex-grow-1 order-sm-2">
            {Title.map((item) => (
              <TitleElement key={item.id} {...item} />
            ))}
          </div>
        )}

        {showCollapsibleMenu ? (
           <>
                <nav className="header-nav mt-3 mt-sm-0 me-sm-5 order-sm-3">
                    <div className="header-content">
                        <img
                            src="https://api.greatspirits.de/strapi-api/uploads/list_591e1e6e7c.png"
                            alt="Menü-Umschalter"
                            className="menu-toggle-image"
                            onClick={toggleMenu}
                            aria-expanded={isMenuOpen}
                            aria-controls="navigation-menu"
                            style={{ width: '40px', height: 'auto' }} 
                        />
                    </div>
               <div className="menu-test">
                  <NavigationMenu 
                    ref={menuRef} 
                    isOpen={isMenuOpen} 
                    onClose={() => setIsMenuOpen(false)} 
                    links={Link}
                  />
                  </div>
             </nav>
          </>
        ) : (
          Link && Link.length > 0 && (
            <nav className="header-nav mt-3 mt-sm-0 me-sm-5 order-sm-3">
              <ul className="d-flex flex-column flex-sm-row gap-2 gap-sm-3 list-unstyled mb-0 justify-content-center align-items-center">
                {Link.map((link) => (
                  <li key={link.id}>
                    <LinkElement {...link} />
                  </li>
                ))}
              </ul>
            </nav>
          )
        )}
      </div>
    </header>
  );
};

export default Header;